'use strict';

/**
 * Colorbox NPM module is not developed like other well developed jQuery plugins in npm.
 * For it to work I need to temporarily make a global reference to jQuery
 * 
 * We also enhance by:
 * - Adding 'isOpen' to the colorbox markup once it is complete
 * - Turn off scrolling of page by hidding scrollbar (we make up for no scrollbar by adding padding-right on html)
 * - On resize of window we trigger resize of colorbox. Without this colorbox keeps at the size it opens at
 */

var $ = require('jquery');
var Debouncer = require('../lib/Debouncer.js');
var toggleBodyScrollbar = require('../lib/toggleBodyScrollbar.js');

window.jQuery = $;
var colorbox = require('jquery-colorbox');
window.jQuery = undefined;

$(document).bind('cbox_open', function() {
	toggleBodyScrollbar(false);
});
$(document).bind('cbox_complete', function() {
	var $colorbox = $('#colorbox');
	$colorbox.removeClass('isClosed');
	$colorbox.addClass('isOpen');
	
	function reResize() {
		var currColorboxSettings = $.colorbox.element().data('colorbox');
		$.colorbox.resize({width: currColorboxSettings.width, height: currColorboxSettings.height});
	}
	
	// Resize if window resizes
	$(window).on('resize.colorboxResize', new Debouncer(reResize, false, 500).run);

	// Resize if images inside colorbox load
	var images = $colorbox.get(0).querySelectorAll('img');
	if (images !== null) {
		for (var i=0; i < images.length; i++) {
			var img = images[i];
			if (!img.complete) {
				img.addEventListener('load', new Debouncer(reResize, false, 50).run, false);
			}
		}
	}
});
$(document).bind('cbox_closed', function() {
	$('#colorbox').removeClass('isClosed');
	$(window).off('resize.colorboxResize');
	
	toggleBodyScrollbar(true);
});
$(document).bind('cbox_cleanup', function() {
	$('#colorbox').removeClass('isOpen');
	$('#colorbox').addClass('isClosed');
});


module.exports = colorbox;
